<template>
  <div class="menutree-box">
    <div class="menutree-int">
      <div class="menutree-left">
        <div v-for="(item,index) in menuchild" :class="item.value == checkMenu?'menutree-item-check':'menutree-item'" @click="gotoPage(item)">
          {{item.lable}}
        </div>
      </div>
      <div class="menutree-right">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) in rightBars" :key="index" :to="{ path: index ==0?'/':'' }">{{item.lable}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props:{
    menuchild:{
      type:Array,
      default:[]
    },
    // crumbs:{
    //   type:Array,
    //   default:[]
    // },
    checkMenu:{
      type:String,
      default:'0'
    },
    rightBars:{
      type:Array,
      default:[]
    }
  },
  methods:{
    gotoPage(item){
      if(item.value != this.checkMenu){
        this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .menutree-box{
    border-bottom: 1px #ebebeb solid;
    height: 60px;
    width: 100%;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    .menutree-int{
      width: 1200px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menutree-left{
        display: flex;
        align-items: center;
        .menutree-item{
          width: 180px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333333;
          font-size: 16px;
          cursor:pointer
        }
        .menutree-item:hover,.menutree-item-check{
          width: 180px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #00a73c;
          color: #FFFFFF;
          font-size: 16px;
          cursor:pointer
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menutree.vue